
export default function formatTimezone(value) {
  // Only display first word for timezone.
  if (typeof value === 'string') {
    const words = value.split(/[\s\-]+/);
    return words.length ? words[0] : value;
  }
  return value;
}



// WEBPACK FOOTER //
// ./shared/lib/prettyTimezone.js